import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../config/supabase';
import Sidebar from '../components/admin/Sidebar';
import TopNavbar from '../components/admin/TopNavbar';
import SettingsSidebar from '../components/admin/settings/SettingsSidebar';
import RestaurantInfo from '../components/admin/settings/RestaurantInfo';
import OperatingHours from '../components/admin/settings/OperatingHours';
import DeliverySettings from '../components/admin/settings/DeliverySettings';
import SuccessToast from '../components/common/SuccessToast';
import './Settings.css';

const Settings = () => {
  const navigate = useNavigate();
  const [adminSession, setAdminSession] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('restaurant');
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  useEffect(() => {
    const session = localStorage.getItem('adminSession') || sessionStorage.getItem('adminSession');
    if (!session) {
      navigate('/admin');
      return;
    }
    setAdminSession(JSON.parse(session));
  }, [navigate]);

  const handleSave = () => {
    // Save settings logic here
    setShowSuccessToast(true);
    setHasUnsavedChanges(false);
    setTimeout(() => setShowSuccessToast(false), 3000);
  };

  const handleSectionChange = (section) => {
    if (hasUnsavedChanges) {
      const confirm = window.confirm('You have unsaved changes. Do you want to save before leaving?');
      if (confirm) {
        handleSave();
      }
    }
    setActiveSection(section);
  };

  const renderActiveSection = () => {
    switch (activeSection) {
      case 'restaurant':
        return <RestaurantInfo onSave={handleSave} onChanges={() => setHasUnsavedChanges(true)} />;
      case 'hours':
        return <OperatingHours onSave={handleSave} onChanges={() => setHasUnsavedChanges(true)} />;
      case 'delivery':
        return <DeliverySettings onSave={handleSave} onChanges={() => setHasUnsavedChanges(true)} />;
      default:
        return <RestaurantInfo onSave={handleSave} onChanges={() => setHasUnsavedChanges(true)} />;
    }
  };

  if (!adminSession) {
    return <div className="loading-screen">Loading...</div>;
  }

  return (
    <div className="settings-page">
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      
      <div className="settings-main">
        <TopNavbar 
          onMenuClick={() => setSidebarOpen(true)}
          adminName={adminSession.username || adminSession.email}
        />
        
        <main className="settings-content">
          <div className="page-header">
            <h1 className="page-title">Settings</h1>
            <nav className="breadcrumb">
              <span>Dashboard</span>
              <span className="breadcrumb-separator">/</span>
              <span>Settings</span>
            </nav>
          </div>

          <div className="settings-layout">
            <SettingsSidebar
              activeSection={activeSection}
              onSectionChange={handleSectionChange}
            />
            <div className="settings-content-area">
              {renderActiveSection()}
            </div>
          </div>

          {showSuccessToast && (
            <SuccessToast
              message="Settings saved successfully!"
              onClose={() => setShowSuccessToast(false)}
            />
          )}
        </main>
      </div>
    </div>
  );
};

export default Settings;

